<template>
    <ParentPage page-type="companies-parent-page"></ParentPage>
</template>
<script lang="ts" setup>
    import {useWebsitePageView} from '#imports';
    import ParentPage from '~/components/ParentPage.vue';

    useWebsitePageView('cms', 'companies');
</script>
